module.exports = __webpack_public_path__ + "components/blogs-header/static/header--large-191203640f3c46f4d273d8ae8504bb96.jpg";